import React from 'react'
import css from '@emotion/css'

import { RegularP, BoldP } from '../about'
import RoadSign from './RoadSign'
import JustinSuit from './JustinSuit'
import { getEmSize } from '../../styles/mixins'
import { breakpoints } from '../../styles/variables'

export default function FirstSection() {
  return (
    <div
      css={css`
        display: flex;
        margin-top: 70px;
        align-items: flex-start;
        padding-bottom: 50px;
        @media (max-width: ${getEmSize(breakpoints.lg)}em) {
          flex-direction: column-reverse;
          margin-top: 10px;
        }
      `}
    >
      <div
        css={css`
          width: 30%;
          @media (max-width: ${getEmSize(breakpoints.lg)}em) {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
          }
        `}
      >
        <RoadSign
          css={css`
            width: 100%;
            height: 460px;
            margin-bottom: 180px;
            @media (max-width: ${getEmSize(breakpoints.lg)}em) {
              display: none;
            }
          `}
        />
        <JustinSuit style={{ width: '100%', height: 660 }} />
      </div>

      <div
        css={css`
          width: 50%;
          padding-left: 100px;
          @media (max-width: ${getEmSize(breakpoints.lg)}em) {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
          }
        `}
      >
        <BoldP>
          If we want the kind of change that we are proposing—ending the student debt crisis, fighting for environmental justice and
          immgration justice, providing healthcare for all people in our country—we need a movement. This is about the courage to reimagine
          our country, build a just society and fight for a livable planet for ourselves and our children. This moment demands a new
          generation of leaders in Congress.
        </BoldP>

        <RegularP>
          Justin Jones is an activist, graduate student, and community organizer in Nashville. Born in Oakland, California, he grew up in
          the East Bay where he attended public school and learned at an early age the importance of speaking up for equality for all. His
          mother, Christine, raised Justin and his sister while putting herself through nursing school. She’s now a registered nurse active
          in the California chapter of National Nurses United. He is the grandson of black, working-class grandparents from the South Side
          of Chicago and Filipino immigrants who migrated to California during the Vietnam War. Growing up, his family, especially his two
          grandmothers, taught him the importance of community involvement, care for the environment, and spirituality.
        </RegularP>
        <RegularP>
          In high school, Justin served as his city’s Youth Commissioner and began organizing for the civil rights of students and policies
          that ensured racial equity, environmental protections, and inclusivity. Justin first saw the power of community organizing as part
          of a successful campaign to force a recall election of three city council members involved in financial mismanagement and corrupt
          practices. In high school, he found himself on the front lines of organizing in Oakland following the murder of Trayvon Martin and
          during student campaigns to repeal nationwide Stand Your Ground laws.
        </RegularP>
        <RegularP>
          His activism has brought him from the streets of Oakland to Ferguson, Missouri; from ceremonies of resistance in Standing Rock to
          the Office of the Governor in the Tennessee State House.
        </RegularP>
        <RegularP>
          Justin came to Fisk University in 2013, where he received the John R. Lewis Scholarship for Social Activism. Inspired by its
          legacy of the student-led movement for civil rights, Justin became involved on campus and in community groups and spent his four
          years organizing student campaigns for the expansion of healthcare in Tennessee, the repeal of restrictive state voter ID laws,
          and community accountability in cases of police brutality against unarmed black victims.   He served on the Board of Directors of
          the Tennessee Healthcare Campaign and has led actions at the Legislature, and across the South, for the expansion of Medicaid. In
          2015, Justin helped file a federal lawsuit against the State of Tennessee for its restrictive voter ID laws that targeted
          students. He has chaired the Nashville Student Organizing Committee and is a recipient of awards from the Tennessee Human Rights
          Commission, ACLU of Tennessee, Tennessee Alliance for Progress, Fisk University Alumni Association, the Vanderbilt Organization of
          Black Graduate Students, and the Nashville NAACP.
        </RegularP>
        <RegularP>
          Justin is in his second year at Vanderbilt Divinity School pursuing a Masters’ in Theological Studies. At Vanderbilt, he focuses
          on spirituality and social activism. He sees faith communities as essential gathering spaces for solidarity and connection in our
          shared pursuit of justice and the beloved community. He continues to preach in congregations around the city. Justin lives in East
          Nashville with his dog, Denali.
        </RegularP>
      </div>
    </div>
  )
}
